'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('@emotion/styled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const StyledSpinningInner = styled__default["default"].div(
  ({
    size,
    transform,
    time,
    color = "#3f747e"
  }) => `
  @keyframes ldio-1ga5p6b2g17 {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  width: ${size || 80}px;
  height: ${size || 80}px;
  box-shadow: 0 1.9px 0 0 ${color};
  transform-origin: ${transform || 40}px ${transform || 40}px;
  animation: ldio-1ga5p6b2g17 ${time || 1.27}s linear infinite;
  border-radius: 50%;
`
);

exports.StyledSpinningInner = StyledSpinningInner;
